import type { IControllerConstructor, Injectable } from "angular";
import { module } from "angular";

import "./AddOperatorStationToAlarmCentral.html";
import AddOperatorStationToAlarmCentralComponentController from "./AddOperatorStationToAlarmCentralComponentController";

import "../Forms/FindAddArcOperatorStation/FindAddArcOperatorStationComponent";

export class AddOperatorStationToAlarmCentralComponent implements ng.IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    public transclude: boolean;

    constructor() {
        this.bindings = {
            resolve: "<",
        };
        this.controller = AddOperatorStationToAlarmCentralComponentController;
        this.templateUrl = "/App/Components/AlarmCentralDialogs/AddOperatorStationToAlarmCentral.html";
    }
}

module("mmManagePortal").component(
    "mmAddOperatorStationToAlarmCentral",
    new AddOperatorStationToAlarmCentralComponent(),
);
